import React, { useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import RegisterForm from '../login/RegisterForm';
import LoginModal from '../login/LoginModal';
import { LoginModalProvider } from '../../context/LoginModalContext';
import { useAnalytics } from '../../context/AnalyticsContext';

const ScheduleLanding: React.FC = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginModalStep, setLoginModalStep] = useState<'email' | 'register'>('email');
    const { trackEvent } = useAnalytics();

  const handleLoginClick = () => {
    setLoginModalStep('email');
    setShowLoginModal(true);
  };

  const handleLoginModalClose = () => {
    setShowLoginModal(false);
    trackEvent('schedule_landing_user_aborted_logging_in');
  };

  const handleLogin = () => {
    setShowLoginModal(false);
    trackEvent('schedule_landing_user_logged_in');
  };

  const handleRegister = () => {
    setShowLoginModal(false);
    trackEvent('schedule_landing_user_registered');
  };

  const handleRegisterFromLanding = () => {
    trackEvent('schedule_landing_user_registered');
  };

  const handleCloseLanding = () => {
    // Not used in landing page, but required by RegisterForm
  };

  return (
    <div className="myplan-page">
      <Header />
      <main className="myplan-main">
        <div className="schedule-landing">
          <div className="schedule-landing-content">
            <div className="schedule-landing-left">
              <h1 className="schedule-landing-title">
                Make camp planning easier this year with Aika
              </h1>

              {/* Feature 1: Scheduling camps */}
              <div className="feature-block">
                <div className="feature-block-content">
                  <h2 className="feature-block-title">Schedule camps throughout the season</h2>
                  <p className="feature-block-description">
                    Organize your entire camp schedule in one calendar view.
                    Easily see which weeks are booked and find the perfect timing for each activity.
                  </p>
                  <ul className="feature-block-list">
                    <li>Visual calendar shows all camps at a glance</li>
                    <li>Manage multiple children's schedules effortlessly</li>
                    <li>See conflicts and gaps in your schedule</li>
                  </ul>
                </div>
                <div className="feature-block-screenshot">
                  <img
                    src="/images/schedule-screenshot.png"
                    alt="Calendar showing scheduled camps throughout the season"
                    className="feature-screenshot-image"
                  />
                </div>
              </div>

              {/* Feature 2: Share calendars */}
              <div className="feature-block">
                <div className="feature-block-screenshot">
                  <img
                    src="/images/schedule-sharing-screenshot.png"
                    alt="Sharing calendars with friends and family"
                    className="feature-screenshot-image"
                  />
                </div>
                <div className="feature-block-content">
                  <h2 className="feature-block-title">Share calendars with friends</h2>
                  <p className="feature-block-description">
                    Collaborate with other parents to coordinate schedule conflicts.
                    Share your calendar with a simple link and stay synchronized.
                  </p>
                  <ul className="feature-block-list">
                    <li>One-click sharing via secure link</li>
                    <li>Real-time updates when schedules change</li>
                    <li>View multiple families' schedules together</li>
                  </ul>
                </div>
              </div>

              {/* Feature 3: Cost summary */}
              <div className="feature-block">
                <div className="feature-block-content">
                  <h2 className="feature-block-title">See summary and cost of all camps</h2>
                  <p className="feature-block-description">
                    Get a complete overview of your camp expenses. Track costs per child,
                    per month, and for the entire season to stay within budget.
                  </p>
                  <ul className="feature-block-list">
                    <li>Total cost breakdown by month and camp</li>
                    <li>Budget tracking across the season</li>
                    <li>Compare costs between different options</li>
                  </ul>
                </div>
                <div className="feature-block-screenshot">
                  <img
                    src="/images/schedule-summary-screenshot.png"
                    alt="Cost summary showing total camp expenses"
                    className="feature-screenshot-image"
                  />
                </div>
              </div>
            </div>

            <div className="schedule-landing-right">
              <div className="schedule-landing-register">
                <h2 className="register-title">Organize Every Camp in One Calendar</h2>
                <p className="register-description">
                  Sign up with your name & email, or Login with Google to get started in seconds.
                </p>

                <LoginModalProvider initialStep="register">
                  <RegisterForm
                    onRegister={handleRegisterFromLanding}
                    onClose={handleCloseLanding}
                  />
                </LoginModalProvider>

                <p className="register-signin-link">
                  Already have an account? <button
                    type="button"
                    className="link-button"
                    onClick={handleLoginClick}
                  >
                    Sign in
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {showLoginModal && (
        <LoginModalProvider initialStep={loginModalStep}>
          <LoginModal onClose={handleLoginModalClose} onLogin={handleLogin} onRegister={handleRegister} />
        </LoginModalProvider>
      )}
    </div>
  );
};

export default ScheduleLanding;
